import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import 'antd/dist/reset.css';     // стили Ant Design

/* ---------- Safari hot-patch ---------- */
if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
  window.addEventListener(
    'keydown',
    (e) => {
      if (e.key === undefined) e.stopImmediatePropagation();
    },
    true
  );
}
/* -------------------------------------- */

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
